import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      {/* Same shell width as the header and the checkout container. */}
      <div className="mx-auto max-w-shell px-4 sm:px-7 py-8">
        <div className="text-center">
          <p className="text-sm text-gray-500">
            © 2025 Decisive Sites. 
          </p>
     
        </div>
      </div>
    </footer>
  );
}
